<script setup>
import { ref, inject, watch, computed, onMounted } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';
import { storeToRefs } from 'pinia';
import * as kaleadicalHelper from '@/utils/kaleadicalHelper';

// const { search } = useKaleadicalStore();
const { active } = storeToRefs(useKaleadicalStore());

const kaleadical = ref({
    thumbnail: '',
    name: '',
    description: '',
    habits: [],
});
const modals = inject('modals');

const openModal = (modal, kaleadical = null) => {
    modals.show(modal, {
        props: kaleadical ? {
            kaleadical: kaleadical,
        } : {},
    }).then(_ => {
        kaleadicalHelper.renderHabits(habits.value, habitContainer.value);
    });;
};

const habitContainer = ref(null);

const habits = computed(() => {
    return kaleadical.value.habits.map((habit, index) => {
        return {
            ...habit,
            size: 100 + index * 5,
        };
    });
});

onMounted(() => {
    if (habits.value.length > 0 && habitContainer.value) {
        kaleadicalHelper.renderHabits(habits.value, habitContainer.value);
    }
});

watch(() => active.value, (value) => {
    kaleadical.value = {
        ...value,
    };
    if (habits.value.length > 0 && habitContainer.value) {
        kaleadicalHelper.renderHabits(habits.value, habitContainer.value);
    }
});

</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template #title>{{ $t('label.kaleadical_management') }}</template>
    <template #actions>
        <div class="text-right">
            <div>
                <StyledButton @click="openModal('TrackHabitModal', active)"><FontAwesomeIcon icon="plus" class="mr-1" />
                    {{  $t('label.track') }}
                </StyledButton>
            </div>
            <div class="mt-2">
                <StyledButton @click="openModal('ShareModal', active)"><FontAwesomeIcon icon="share" class="mr-1" />
                    {{  $t('label.share') }}
                </StyledButton>
            </div>
        </div>
        <!-- <StyledButton @click="openModal('TrackHabitModal', active)"><FontAwesomeIcon icon="plus" class="mr-1" />
            {{  $t('label.track') }}
        </StyledButton>
        <StyledButton @click="openModal('TrackHabitModal', active)"><FontAwesomeIcon icon="plus" class="mr-1" />
            {{  $t('label.share') }}
        </StyledButton> -->
    </template>
    <div class="grid lg:grid-cols-3 md:gap-4 md:mb-4">
        <div class="">
            <svg
                ref="habitContainer"
                width="600"
                height="600"
                viewBox="0 0 600 600"
                xmlns="http://www.w3.org/2000/svg" />
        </div>
    </div>
    
</MainContentLayout>
</template>
